import ReactVisibilitySensor from "react-visibility-sensor";
import Counter from "../../Counter/Counter";
import { useContext } from "react";
import { LangContext } from "../../../App";

type Item = {
    number? : number;
    spanOne? : string;
    spanTwo? : string;
    text? : string;
    icon? : {
        src : string;
        alt : string;
    };
    unit? : string;
    title? : string;
}
type FlexViewBorderProps = {
    items : Item[];
}

const FlexViewBorder = ({ items } : FlexViewBorderProps) => {
    const { lang } = useContext(LangContext);

  return (
    <div className={`flex-view-border ${lang ? "rtl" : ""}`}>
        {items.map((item, index) => (
            <ReactVisibilitySensor>
            {({isVisible} : any) => (
            <div key={index} className={`flex-view-col ${index === 0 ? "first-item" : ""} ${isVisible ? "visible" : ""}`}>
                {item.icon ? 
                <img src={item.icon.src} alt={item.icon.alt} aria-hidden="true" className="flex-icon" />
                : ""}
                {item.spanOne ? 
                <p className={`view-label an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.spanOne}</p> 
                : ""}
                {item.title ? 
                <p className="view-number">
                    {item.title}
                </p> : ""}
                {item.number ?
                <p className="view-number">
                    {lang ? item.unit ? <span>{item.unit}</span> : "" : ""}
                    <Counter 
                        counterValue={item.number}
                        applyCounteClassName=""
                    />
                    {!lang ? item.unit ? <span>{item.unit}</span> : "" : ""}
                </p>
                : ""}
                {item.text ?
                <p className={`view-text an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.text}</p>
                : ""}
                {item.spanTwo ?
                <p className={`view-label an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.spanTwo}</p>
                : ""}
            </div>
            )}
            </ReactVisibilitySensor>
        ))}
    </div>
  )
}

export default FlexViewBorder